export function norm(val, max, min) {
  return (val - min) / (max - min);
}
